// Links players open. With TC_PUBLIC_URL set on the server, links always use that address (so a
// host who opened the app by LAN IP still shares the public domain); otherwise they use the
// address this browser is on, which behind a reverse proxy is already the public domain.

export function joinUrl(code: string, publicUrl: string | null, currentOrigin: string): string {
  const base = (publicUrl || currentOrigin).replace(/\/+$/, "");
  return `${base}/join/${encodeURIComponent(code)}`;
}
